// Package Imports

import { ExclamationCircleOutlined } from '@ant-design/icons';
import { Modal } from 'antd';

const CustomModal = ({
  openModal,
  hideModal,
  title,
  okText,
  cancelText,
  message,
  footer,
}: any) => (
  <Modal
    title={
      <span>
        <ExclamationCircleOutlined
          style={{ color: 'red', marginRight: '5px' }}
        />
        {title}
      </span>
    }
    open={openModal}
    onOk={() => hideModal(okText)}
    onCancel={() => hideModal(cancelText)}
    okText={okText}
    cancelText={cancelText}
    footer={footer}
    maskClosable={false}
  >
    <p>
      <b>{message}</b>{' '}
    </p>
  </Modal>
);
export default CustomModal;
